export var ua = navigator.userAgent;
export var VERSION;
(function (VERSION) {
    VERSION["V0"] = "0.0.0";
    VERSION["V1"] = "1.0.0";
    VERSION["V1_1_0"] = "1.1.0";
    VERSION["V1_2_0"] = "1.2.0";
    VERSION["V1_3_0"] = "1.3.0";
    VERSION["V1_4_0"] = "1.4.0";
    VERSION["V1_5_0"] = "1.5.0";
    VERSION["V1_6_0"] = "1.6.0";
    VERSION["V1_8_1"] = "1.8.1";
    VERSION["V1_9_0"] = "1.9.0";
})(VERSION || (VERSION = {}));
export var APP_UA;
(function (APP_UA) {
    APP_UA["SOLAR"] = "YuanSouTi";
    APP_UA["LEO"] = "YuanSouTiKouSuan";
    APP_UA["TUTOR"] = "YuanFuDao";
    APP_UA["APE"] = "YuanTiKu";
})(APP_UA || (APP_UA = {}));
export var DEVICES;
(function (DEVICES) {
    DEVICES["ANDROID"] = "android";
    DEVICES["IOS"] = "ios";
})(DEVICES || (DEVICES = {}));
export var SHARE_TYPE;
(function (SHARE_TYPE) {
    SHARE_TYPE[SHARE_TYPE["LINK"] = 0] = "LINK";
    SHARE_TYPE[SHARE_TYPE["IMAGE"] = 1] = "IMAGE";
})(SHARE_TYPE || (SHARE_TYPE = {}));
export var ENUM_PLATFORM_V1;
(function (ENUM_PLATFORM_V1) {
    ENUM_PLATFORM_V1[ENUM_PLATFORM_V1["weibo"] = 1] = "weibo";
    ENUM_PLATFORM_V1[ENUM_PLATFORM_V1["moments"] = 2] = "moments";
    ENUM_PLATFORM_V1[ENUM_PLATFORM_V1["wechat"] = 3] = "wechat";
    ENUM_PLATFORM_V1[ENUM_PLATFORM_V1["qzone"] = 4] = "qzone";
    ENUM_PLATFORM_V1[ENUM_PLATFORM_V1["qq"] = 5] = "qq";
})(ENUM_PLATFORM_V1 || (ENUM_PLATFORM_V1 = {}));
export var ENUM_SHARE_CALLBACK_PLATFORM_V0;
(function (ENUM_SHARE_CALLBACK_PLATFORM_V0) {
    ENUM_SHARE_CALLBACK_PLATFORM_V0[ENUM_SHARE_CALLBACK_PLATFORM_V0["weibo"] = 1] = "weibo";
    ENUM_SHARE_CALLBACK_PLATFORM_V0[ENUM_SHARE_CALLBACK_PLATFORM_V0["pyq"] = 2] = "pyq";
    ENUM_SHARE_CALLBACK_PLATFORM_V0[ENUM_SHARE_CALLBACK_PLATFORM_V0["wechat"] = 3] = "wechat";
    ENUM_SHARE_CALLBACK_PLATFORM_V0[ENUM_SHARE_CALLBACK_PLATFORM_V0["qzone"] = 4] = "qzone";
    ENUM_SHARE_CALLBACK_PLATFORM_V0[ENUM_SHARE_CALLBACK_PLATFORM_V0["qq"] = 5] = "qq";
})(ENUM_SHARE_CALLBACK_PLATFORM_V0 || (ENUM_SHARE_CALLBACK_PLATFORM_V0 = {}));
export var ENUM_PLATFORM_V0_IOS;
(function (ENUM_PLATFORM_V0_IOS) {
    ENUM_PLATFORM_V0_IOS[ENUM_PLATFORM_V0_IOS["SinaWeibo"] = 1] = "SinaWeibo";
    ENUM_PLATFORM_V0_IOS[ENUM_PLATFORM_V0_IOS["WeChatTimeline"] = 2] = "WeChatTimeline";
    ENUM_PLATFORM_V0_IOS[ENUM_PLATFORM_V0_IOS["WeChat"] = 3] = "WeChat";
    ENUM_PLATFORM_V0_IOS[ENUM_PLATFORM_V0_IOS["Qzone"] = 4] = "Qzone";
    ENUM_PLATFORM_V0_IOS[ENUM_PLATFORM_V0_IOS["QQ"] = 5] = "QQ";
})(ENUM_PLATFORM_V0_IOS || (ENUM_PLATFORM_V0_IOS = {}));
export var ENUM_PLATFORM_V0_ANDROID;
(function (ENUM_PLATFORM_V0_ANDROID) {
    ENUM_PLATFORM_V0_ANDROID[ENUM_PLATFORM_V0_ANDROID["SinaWeibo"] = 1] = "SinaWeibo";
    ENUM_PLATFORM_V0_ANDROID[ENUM_PLATFORM_V0_ANDROID["WeChatTimeline"] = 2] = "WeChatTimeline";
    ENUM_PLATFORM_V0_ANDROID[ENUM_PLATFORM_V0_ANDROID["WeChat"] = 3] = "WeChat";
    ENUM_PLATFORM_V0_ANDROID[ENUM_PLATFORM_V0_ANDROID["QZone"] = 4] = "QZone";
    ENUM_PLATFORM_V0_ANDROID[ENUM_PLATFORM_V0_ANDROID["QQ"] = 5] = "QQ";
})(ENUM_PLATFORM_V0_ANDROID || (ENUM_PLATFORM_V0_ANDROID = {}));
export var NETWORK_TYPE;
(function (NETWORK_TYPE) {
    NETWORK_TYPE["OFFLINE"] = "offline";
    NETWORK_TYPE["WIFI"] = "wifi";
    NETWORK_TYPE["WWAN"] = "WWAN";
    NETWORK_TYPE["TWO_G"] = "2G";
    NETWORK_TYPE["THREE_G"] = "3G";
    NETWORK_TYPE["FOUR_G"] = "4G";
    NETWORK_TYPE["UNKNOWN"] = "unknown";
})(NETWORK_TYPE || (NETWORK_TYPE = {}));
export var SIM_TYPE;
(function (SIM_TYPE) {
    SIM_TYPE["MOBILE"] = "mobile";
    SIM_TYPE["UNICOM"] = "unicom";
    SIM_TYPE["TELECOM"] = "telecom";
    SIM_TYPE["UNKNOWN"] = "unknown";
})(SIM_TYPE || (SIM_TYPE = {}));
// 1 无网；2 加载失败；3 正在加载；4 隐藏正在加载/加载失败/无网
export var REFRESH_STATE;
(function (REFRESH_STATE) {
    REFRESH_STATE[REFRESH_STATE["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
    REFRESH_STATE[REFRESH_STATE["LOADING_ERROR"] = 2] = "LOADING_ERROR";
    REFRESH_STATE[REFRESH_STATE["LOADING"] = 3] = "LOADING";
    REFRESH_STATE[REFRESH_STATE["HIDE"] = 4] = "HIDE";
})(REFRESH_STATE || (REFRESH_STATE = {}));
export var FULL_SCREEN_PLAY_STAUTS;
(function (FULL_SCREEN_PLAY_STAUTS) {
    FULL_SCREEN_PLAY_STAUTS[FULL_SCREEN_PLAY_STAUTS["PLAYLING"] = 1] = "PLAYLING";
    FULL_SCREEN_PLAY_STAUTS[FULL_SCREEN_PLAY_STAUTS["PAUSED"] = 2] = "PAUSED";
    FULL_SCREEN_PLAY_STAUTS[FULL_SCREEN_PLAY_STAUTS["FINISHED"] = 3] = "FINISHED";
})(FULL_SCREEN_PLAY_STAUTS || (FULL_SCREEN_PLAY_STAUTS = {}));
export var LEFT_BUTTON_CLICK_EVENT = 'webViewLeftButtonClicked';
export var RIGHT_BUTTON_CLICK_EVENT = 'webViewRightButtonClicked';
export var SHARE_EVENT = 'webViewShare';
export var LOGIN_EVENT = 'webviewLogin';
